// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__KREAZ","active":"Navbar_active__M2s3Q","link":"Navbar_link__TtF-3"};